/**
 * Thin wrapper over gtag.
 *
 * Before this existed the site sent six events, all of them money or exam
 * related (purchase, begin_checkout, premium_modal_open, exam_start,
 * exam_complete). Everything else a visitor could do — Quick-Fire, the More
 * menu, setting a test date, flipping a flashcard, asking for the free cheat
 * sheet — was invisible in GA4, so questions like "does anyone use Quick-Fire?"
 * had no answer at all. GA4 cannot report an event that was never sent, and
 * Search Console only ever sees Google search traffic, never in-app behaviour.
 *
 * Every call is guarded: gtag is absent in development, in tests, and for
 * visitors running an ad blocker, and analytics must never break the app.
 */

/**
 * Send a GA4 event.
 *
 * @param {string} name   snake_case event name, as GA4 expects.
 * @param {object} params optional event parameters. Keep these low-cardinality
 *                        (a topic name, a bucket, a boolean) — never anything
 *                        that identifies a person. GA4 custom dimensions have
 *                        to be registered against the parameter name before
 *                        they are reportable, so adding a parameter here is
 *                        only half the job; see docs/seo-and-funnel-state.md.
 */
export function track(name, params = {}) {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    }
  } catch {
    // Analytics is never worth an exception in a user's session.
  }
}

export default track;
